module.exports = __webpack_public_path__ + "img/morning-usage-icon.ca96ae52.svg";